import React, { useRef } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import FormikControl from "../../componenets/FormikReusable/FormikControl";
import ProfileImagePreview from "../../componenets/FormikReusable/ProfileImagePreview";
import { useNavigate } from "react-router-dom";

export const RegisterFormik = () => {
  const navigate = useNavigate();
  const options = [
    { key: "below18", value: "below18" },
    { key: "Above18", value: "above18" },
    { key: "Equal18", value: "eq18" },
  ];
  const initialvalues = {
    email: "",
    password: "",
    confirmpassword: "",
    modeofContact: "below18",
    voterId: "",
    file: null,
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string().required().email("Invalid Email Format"),
    password: Yup.string().required("Password Required").min(6).max(50),
    confirmpassword: Yup.string()
      .required("required")
      .oneOf([Yup.ref("password"), ""], "Password must match"),
    modeofAge: Yup.boolean(),
    voterId: Yup.mixed().when("modeofContact", {
      is: "above18",
      then: () => {
        return Yup.string().required("Required");
      },
      otherwise: () => {
        return Yup.string().notRequired("Not Required");
      },
    }),
    file: Yup.mixed()
      .nullable()
      .required()
      .test(
        "FILE_TYPE",
        "invalid!",
        (value) => value && ["image/png", "image/jpeg"].includes(value.type)
      )
      .test(
        "FILE_SIZE",
        "Uploaded file is too big.",
        (value) => !value || (value && value.size <= 1024 * 1024)
      ),
  });
  const onSubmit = (values) => {
    console.log("form data ", values);
    navigate("/RegistrationPreview", { state: values });
  };
  const fileref = useRef(null);

  return (
    <>
      <h1 className="text-center">Student Registration Form</h1>

      <Formik
        initialValues={initialvalues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        validateOnMount
      >
        {(formik) => {
          {
            /* console.log("Formik props" , formik) */
          }
          const { values } = formik;
          return (
            <div
              className="container shadow "
              style={{ marginTop: "25px", width: "500px" }}
            >
              <Form>
                <div className="row">
                  <div className="profile-pic">
                    {values.file && <ProfileImagePreview file={values.file} />}
                    <button
                      type="button"
                      onClick={() => fileref.current.click()}
                    >
                      Upload
                    </button>
                    <input
                      ref={fileref}
                      type="file"
                      hidden
                      onChange={(e) =>
                        formik.setFieldValue("file", e.target.files[0])
                      }
                    />
                  </div>
                  {formik.errors.file ? (
                    <p style={{ color: "red" }}> {formik.errors.file} </p>
                  ) : (
                    "null"
                  )}
                </div>
                <FormikControl
                  control="input"
                  type="email"
                  label="Email"
                  name="email"
                />
                <FormikControl
                  control="input"
                  type="password"
                  label="Password"
                  name="password"
                />
                <FormikControl
                  control="input"
                  type="password"
                  label="ConfirmPassword"
                  name="confirmpassword"
                />
                <br />
                <FormikControl
                  control="radio"
                  label="AgeGroup"
                  name="modeofContact"
                  options={options}
                />
                <br /> <br />
                <FormikControl
                  control="input"
                  type="text"
                  label="VoterID"
                  name="voterId"
                />
                <button
                  type="submit"
                  style={{ margin: "10px" }}
                  disabled={!(formik.isValid || formik.isSubmitting)}
                >
                  Submit
                </button>
              </Form>
            </div>
          );
        }}
      </Formik>
    </>
  );
};
